import { Pipe, PipeTransform, inject } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { OrganizationNameService } from './organization-name.service';

@Pipe({ name: 'organizationName' })
export class OrganizationNamePipe implements PipeTransform {
  private organizationNameService = inject(OrganizationNameService);

  transform(value: string[] | string | null | undefined): Observable<string> {
    if (value === null || value === undefined) {
      return of('');
    }
    let ids = typeof value === 'string' ? [value] : value;
    if (!ids.length) {
      return of('');
    }

    ids = ids.map((id) => id.trim());
    return this.organizationNameService
      .getNameMap(ids)
      .pipe(
        map(
          (orgMap) => ids.map((v) => orgMap[v]).join('<br>'),
        ),
      );
  }
}
